function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.3 40.8L0 20.5 20.3.2l.7.7L1.3 20.5 21 40.1z"
});

function SvgThinArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 41"
  }, props), _ref);
}

export default "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 21 41'%3E %3Cpath d='M20.3 40.8L0 20.5 20.3.2l.7.7L1.3 20.5 21 40.1z'/%3E %3C/svg%3E";
export { SvgThinArrow as ReactComponent };